import React from "react";
import FilterableDropdown from "./FilterableDropdown";
import SearchIcon from "@mui/icons-material/Search";
import { RefreshCw } from "lucide-react";
import { FaGoogle } from "react-icons/fa6";
import { SiAmazon } from "react-icons/si";
import { VscAzure } from "react-icons/vsc";


const CloudIcon = ({ provider }) => {
    if (provider.toLowerCase().includes("gcp")) return <FaGoogle className="w-8 h-8 text-primary" />;
    if (provider.toLowerCase().includes("aws")) return <SiAmazon className="w-8 h-8 text-primary" />;
    return <VscAzure className="w-8 h-8 text-primary" />;
};

const TailwindFilterHeader = ({
  title,
  subtitle,
  dropdowns = [],
  tabs = [],
  activeTab,
  onTabChange,
  isSyncing,
  onSync,
  extraActions,
  searchTerm,
  handleSearchChange,
  isSearchNeeded = false,
  isSyncNeeded = true,
  isdropDownNeeded = true,
  isIconNeeded = false,
}) => {
  return (
    <div className="border-b bg-card text-foreground font-sans">
      {/* ================= Header Section ================= */}
      <div className="px-6 py-5 flex flex-col md:flex-row md:items-center justify-between gap-6">
        {/* ---------- Title + Subtitle ---------- */}
        {isIconNeeded && (
              <CloudIcon provider={title} />
            )}
        <div>
          
          <div className="flex items-center gap-2">
            
            <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
          </div>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>

        {/* ---------- Filters, Search & Sync ---------- */}
        <div className="flex flex-wrap items-end gap-4 ml-auto">
          {isdropDownNeeded &&
            dropdowns.map(({ label, value, options, onChange }, idx) => (
              <div key={idx}>
                <label className="text-xs font-medium mb-1.5 block text-muted-foreground">
                  {label}
                </label>
                <div className="min-w-[180px]">
                  <FilterableDropdown
                    label=""
                    value={value}
                    options={options}
                    onChange={onChange}
                  />
                </div>
              </div>
            ))}

          {isSearchNeeded && (
            <div>
              <label className="text-xs font-medium mb-1.5 block text-muted-foreground">
                Search
              </label>
              <div className="relative">
                <SearchIcon
                  fontSize="small"
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
                />
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => handleSearchChange(e)}
                  className="pl-9 pr-4 py-2 text-sm rounded-md border border-input bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/80 transition-all duration-150 min-w-[220px]"
                />
              </div>
            </div>
          )}

          <div className="flex items-center gap-3">
            {extraActions && <div>{extraActions}</div>}
            {isSyncNeeded && (
              <button
                onClick={onSync}
                disabled={isSyncing}
                className={`px-4 py-2 rounded-md text-sm font-medium flex items-center gap-2 transition-all duration-150 shadow-sm
                  ${
                    isSyncing
                      ? "bg-gray-400 dark:bg-gray-600 text-white cursor-not-allowed"
                      : "bg-primary text-primary-foreground hover:bg-primary/90 active:scale-[0.98]"
                  }`}
              >
                {isSyncing ? (
                  <>
                    <RefreshCw className={`w-4 h-4 ${isSyncing ? "animate-spin" : ""}`} />
                    <span>Syncing...</span>
                  </>
                ) : (
                  <>Sync</>
                )}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* ================= Tabs Section ================= */}
      {tabs.length > 0 && (
        <div className="px-6 py-3 border-t flex flex-wrap justify-center gap-2 md:gap-4 bg-muted/20">
          {tabs.map((tab, idx) => (
            <button
              key={idx}
              onClick={() => onTabChange(tab.value)}
              className={`px-5 py-2.5 rounded-md text-sm md:text-base font-medium flex items-center gap-2 transition-all duration-200 tracking-wide
                ${
                  activeTab === tab.value
                    ? "bg-primary text-primary-foreground shadow-sm"
                    : "bg-muted/50 text-muted-foreground hover:bg-muted/80 hover:text-foreground"
                }`}
            >
              {tab.icon && <tab.icon className="w-4 h-4" />}
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TailwindFilterHeader;
